import React from "react";

import Image from "next/image";

const UspWhat: React.FC = () => {
  return (
    <>
      <div className="w-full md:pt-[70px] pt-[32px] md:pb-[70px] pb-[32px] md:bg-[url(/images/accounting/usp/whatis_bg.png)] bg-[url(/images/accounting/usp/whatis_bg.png)] bg-no-repeat bg-cover">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden">
          <div className="text-center">
            <h2 className=" flex justify-center lg:text-[36px] md:text-[38px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-[#0C1F33] text-center mx-auto px-[4px]">
              What is
              <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2 ml-2">
                the US Pathway for Accou
              </span>
              ntants{" "}
              <span>
                <Image
                  src="/images/accounting/usp/Question.png"
                  alt="Miles US Pathway"
                  className="w-[26px] ml-2"
                  width={69}
                  height={127}
                  priority
                />
              </span>
            </h2>
          </div>

          <div className="flex justify-between 2xl:w-[1100px] md:w-[1000px] mx-auto md:mt-10">
            <div className="2xl:w-[48%] w-[47%]">
              <h2 className="text-center text-[#3174d6] text-[32px] font-semibold">
                1 year <span className="text-[#393939]">of Study</span>
              </h2>
              <p className="text-center text-[20px] text-[#585858] font-medium">
                Master’s from top universities in the US
              </p>
              <p className="2xl:text-[26px] xl:text-[27px] font-semibold leading-[43.43px] tracking-[-2.37px] text-black bg-[#FFBA08] px-0 text-center 2xl:w-[38%] xl:w-[44%] mx-auto mt-2 ">
                STEM-designated
              </p>

              <div className="flex justify-between flex-wrap">
                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/x1.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Ohio
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/x2.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[66px] h-[46px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Michigan
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/x3.svg"
                      alt="Miles US Pathway"
                      className="mx-auto w-[55px]"
                      width={64}
                      height={65}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New Jersey
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/y1.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Illinois
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/y2.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[80px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Louisiana
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/y3.png"
                      alt="Miles US Pathway"
                      className="mx-auto"
                      width={44}
                      height={50}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New York
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/dela.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[70px]"
                      width={180}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Delaware
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/z2.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Massachusetts
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/z3.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New York
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="2xl:w-[48%] w-[47%]">
              <h2 className="text-center text-[#3174d6] text-[32px] font-semibold">
                3 years <span className="text-[#393939]">of Work</span>
              </h2>
              <p className="text-center text-[20px] text-[#585858] font-medium">
                at CPA firms in the US
              </p>
              <p className="2xl:text-[22px] xl:text-[27px] font-semibold leading-[43.43px] tracking-[-2.37px] text-black bg-[#FFBA08] px-0 text-center 2xl:w-[42%] xl:w-[55%] mx-auto mt-2">
                <span className="text-[26px] font-semibold leading-[32px] tracking-[-2.527px]">
                  {" "}
                  $60,000+{" "}
                </span>
                (₹50+ lakhs)
              </p>

              <div className="flex justify-between flex-wrap">
                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/l7.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[75px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New York
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/sikich.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[100px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0 "
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Naperville
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/blue.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[70px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0 "
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Carmel
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px] ">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/bpb.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[80px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0 "
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New York
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px] ">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/pra.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[80px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0 "
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      New York
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/pya.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Atlanta
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/accounting/l5.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[60px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Wisconsin
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/hota.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[90px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      Oklahoma
                    </p>
                  </div>
                </div>

                <div className="location_box  py-[10px] bg-white mt-[30px] 2xl:w-[160px] w-[140px] h-[124px]">
                  <div className="h-[70px] flex items-center">
                    <Image
                      src="/usp/hb.png"
                      alt="Miles US Pathway"
                      className="mx-auto w-[50px]"
                      width={60}
                      height={60}
                      priority
                    />
                  </div>
                  <div className="flex items-center justify-center ">
                    <Image
                      src="/accounting/logo-usp/location.png"
                      alt="Miles US Pathway"
                      className="mr-0"
                      width={23}
                      height={23}
                      priority
                    />
                    <p className="2xl:text-[16px] md:text-[14px] font-medium leading-[31.792px] tracking-[-0.8px] text-[#535353]">
                      California
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <Image
                  src="/accounting/logos.svg"
                  alt="Miles US Pathway"
                  className="mt-10 mx-auto w-[90%]"
                  width={900}
                  height={545}
                  priority
                /> */}
        </div>
      </div>
    </>
  );
};

export default UspWhat;
